// Vendor libraries

import Vue from "vue";
import Buefy from "buefy";
import VueMeta from "vue-meta";
import VueMq from "vue-mq";

// Local libraries

import { i18n } from "@/services/i18n";
import "@/services/helpers";

import Helpers from "@/plugins/helpers";
import Sentry from "@/plugins/sentry";
import Http from "@/plugins/http";
import Notificator from "@/plugins/notificator";
import Loading from "@/plugins/loading";
import Form from "@/plugins/form";
import Dashboard from "@/plugins/dashboard";

Vue.config.productionTip = false;

Vue.prototype.$registration = window.Registration;

/*
|--------------------------------------------------------------------------
| Vendor Plugins
|--------------------------------------------------------------------------
*/

Vue.use(VueMeta);
Vue.use(Buefy);
Vue.use(VueMq, {
  breakpoints: {
    mobile: 640,
    tablet: 1024,
    desktop: 1280,
    widescreen: 1536,
    fullhd: Infinity
  }
});

/*
|--------------------------------------------------------------------------
| Local Plugins
|--------------------------------------------------------------------------
*/

// The order is important!
Vue.use(Sentry);
Vue.use(Notificator);
Vue.use(Http);
Vue.use(Helpers);
Vue.use(Loading);
Vue.use(Form);
Vue.use(Dashboard);

/*
|--------------------------------------------------------------------------
| Global components
|--------------------------------------------------------------------------
*/

Vue.component("v-layout", require("./layout.vue").default);
Vue.component("v-start", require("./components/start/index.vue").default);
Vue.component("v-step-information", require("./components/steps/Information.vue").default);
Vue.component("v-step-driving-licence", require("./components/steps/DrivingLicence.vue").default);
Vue.component("v-step-insurance", require("./components/steps/Insurance.vue").default);
Vue.component("v-end", require("./components/End.vue").default);
Vue.component("v-already-registered", require("./components/AlreadyRegistered.vue").default);

new Vue({
  el: "#app",
  i18n
});
